import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import enLang from './locales/en/en.json';
import frLang from './locales/fr/fr.json';
import deLang from './locales/de/de.json';
import esLang from './locales/es/es.json';
import ptLang from './locales/pt/pt.json';
import slLang from './locales/sl/sl.json';

import { languages } from './languages';

const langDetectorOptions = {
  // order and from where user language should be detected
  order: ['localStorage', 'cookie', 'navigator'],

  // keys or params to lookup language from
  lookupCookie: 'locale',
  lookupLocalStorage: 'locale',

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // only detect languages that are in the whitelist
  checkWhitelist: true,
};

const resources = {
  en: {
    translation: enLang,
  },
  fr: {
    translation: frLang,
  },
  de: {
    translation: deLang,
  },
  es: {
    translation: esLang,
  },
  pt: {
    translation: ptLang,
  },
  sl: {
    translation: slLang,
  },
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: true,
    supportedLngs: languages.map((lang) => lang.value),
    detection: langDetectorOptions,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
